import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { MessageCircleIcon, BookOpenIcon, UsersIcon } from 'lucide-react';
export function HowItWorksSection() {
  const whatsappLink = 'https://wa.me/17863975041?text=Hola%20Ricmary%2C%20quiero%20recibir%20el%20ebook%20GRATIS%20%22El%20Blindaje%20Familiar%20en%20USA%22.%20Vivo%20en%20%5BTU%20ESTADO%5D%20y%20quiero%20orientaci%C3%B3n%20para%20proteger%20a%20mi%20familia.';
  const steps = [{
    icon: <MessageCircleIcon className="w-8 h-8 text-navy" data-id="element-130" />,
    title: 'Me escribes por WhatsApp',
    number: '1'
  }, {
    icon: <BookOpenIcon className="w-8 h-8 text-navy" data-id="element-131" />,
    title: 'Te envío el ebook gratis',
    number: '2'
  }, {
    icon: <UsersIcon className="w-8 h-8 text-navy" data-id="element-132" />,
    title: 'Si deseas, te oriento para que entiendas opciones reales según tu situación',
    number: '3'
  }];
  const containerVariants = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };
  return <section className="bg-cream py-20 px-6" data-id="element-133">
      <div className="max-w-5xl mx-auto" data-id="element-134">
        <div className="text-center mb-16" data-id="element-135">
          <h2 className="font-heading text-3xl md:text-4xl text-navy font-bold" data-id="element-136">
            ¿Cómo funciona?
          </h2>
          <div className="w-16 h-1 bg-gold mx-auto mt-4 rounded-full" data-id="element-137" />
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12 mb-16 relative" data-id="element-138">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[15%] right-[15%] h-0.5 bg-gold/30 z-0" data-id="element-139" />

          {steps.map((step, index) => <motion.div key={index} variants={itemVariants} className="relative z-10 flex flex-col items-center text-center" data-id="element-140">
              <div className="w-24 h-24 rounded-full bg-white shadow-lg flex items-center justify-center mb-6 relative border-4 border-cream" data-id="element-141">
                <div className="absolute -top-3 -right-3 w-8 h-8 rounded-full bg-gold text-white font-bold flex items-center justify-center text-sm" data-id="element-142">
                  {step.number}
                </div>
                {step.icon}
              </div>
              <p className="text-lg font-medium text-navy max-w-[250px]" data-id="element-143">
                {step.title}
              </p>
            </motion.div>)}
        </motion.div>

        <div className="text-center" data-id="element-144">
          <a href={whatsappLink} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-3 bg-whatsapp hover:bg-whatsapp-hover text-white px-8 py-4 rounded-xl font-bold text-lg transition-all shadow-lg hover:shadow-xl hover:-translate-y-1" data-id="element-145">
            <MessageCircleIcon className="w-6 h-6" data-id="element-146" />
            Recibir por WhatsApp
          </a>
        </div>
      </div>
    </section>;
}